import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _uniqBy from 'lodash/uniqBy';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import { makeSelectAuth } from 'containers/Auth/selectors';
import fetchTrends from '../services/fetchTrends';
import formatTrends from '../utils/formatTrends';

const useTrendsData = ({ slug, displayIntervals, type, component }) => {
  const [answers, setAnswers] = useState([]);
  const auth = useSelector(makeSelectAuth());
  const firebase = useFirebase();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const userId = _get(auth, 'uid');

    if (userId) {
      const unsubscribe = firebase
        .firestore()
        .collection('user_resources')
        .doc(userId)
        .collection('taken_assessments')
        .where('assessment.slug', '==', slug)
        .orderBy('timestamp', 'desc')
        .limit(10)
        .onSnapshot(snapshot => {
          const docs = snapshot.docs.map(doc => doc.data());
          const latestAnswers = _uniqBy(
            docs.map(doc => ({
              answers: doc.result,
              timestamp: doc.timestamp,
              date: format(doc.timestamp, 'MMM-dd-yy'),
            })),
            'date',
          )
            .slice(0, 5)
            .reverse();
          setAnswers(latestAnswers);
        });

      return () => unsubscribe();
    }
  }, [auth]);

  const { valueDirection, maxValue, minValue } = component;

  const { data } = useQuery(
    !_isEmpty(answers) && [
      'trends-scorings',
      {
        answers,
        slug,
      },
    ],
    fetchTrends,
  );

  const formattedData = formatTrends({
    answers,
    data,
    valueDirection,
    maxValue,
    minValue,
    displayIntervals,
    type,
    scoringsIndex: component.index,
  });

  return formattedData;
};

export default useTrendsData;
